module.exports = __webpack_public_path__ + "img/cvc.b450d4c4.png";